// Velocity Lab System - Multi-language translations
export const LANGUAGES = [
  { code: "pl", label: "Polski", flag: "PL" },
  { code: "en", label: "English", flag: "EN" },
  { code: "de", label: "Deutsch", flag: "DE" },
  { code: "es", label: "Español", flag: "ES" },
  { code: "fr", label: "Français", flag: "FR" },
  { code: "uk", label: "Українська", flag: "UA" },
];

export const translations = {
  pl: {
    appName: "Velocity Lab System",
    tagline: "Elite Global Performance Courses",
    chooseModule: "Wybierz moduł treningowy",
    difficulty: "Poziom trudności",
    difficultyEasy: "Łatwy",
    difficultyMedium: "Średni",
    difficultyHard: "Trudny",
    difficultyExtreme: "Ekstremalny",
    metronome: "Metronom",
    metronomeDesc: "4 tempa: 100 / 120 / 140 / 160 BPM",
    colors: "Kolory",
    colorsDesc: "Losowe kolory co sekundę",
    colorsNumbers: "Kolory + Liczby",
    colorsNumbersDesc: "Kolory i liczby 1–10 losowo",
    math: "Matematyka",
    mathDesc: "Działania na dodawanie 1–10",
    arrows: "Strzałki",
    arrowsDesc: "Losowe strzałki: góra / dół / lewo / prawo",
    arrowsDiag: "Strzałki + skos",
    arrowsDiagDesc: "8 kierunków łącznie ze skosami",
    tutorial: "Samouczek",
    tutorialDesc: "Poznaj wszystkie funkcje krok po kroku",
    tutorialVideoTitle: "Film instruktażowy",
    tutorialVideoSoon: "Film prezentuje wszystkie moduły aplikacji wraz z opisami w języku angielskim — wybierz moduł niżej, aby od razu rozpocząć trening.",
    tutorialFeaturesTitle: "Funkcje aplikacji",
    tutorialOpenModule: "Otwórz moduł",
    tutorialSteps: "Co musisz zrobić:",
    start: "Start",
    stop: "Stop",
    pause: "Pauza",
    back: "Powrót",
    bpm: "BPM",
    selectTempo: "Wybierz tempo",
    interval: "Szybkość wyświetlania",
    seconds: "sekund",
    second: "sekunda",
    settings: "Ustawienia",
    fullscreen: "Pełny ekran",
    exitFullscreen: "Wyjdź z pełnego ekranu",
    home: "Strona główna",
    language: "Język",
    readyToStart: "Gotowy do treningu?",
    tapToStart: "Kliknij START, aby rozpocząć",
    elapsedTime: "Czas treningu",
    beats: "Uderzenia",
    correctAnswers: "Poprawne",
    skipQuestion: "Pomiń",
    yourAnswer: "Twoja odpowiedź",
    soundOn: "Dźwięk włączony",
    soundOff: "Dźwięk wyłączony",
    welcomeSubtitle: "Profesjonalna platforma treningowa dla piłkarzy",
    chooseLanguage: "Wybierz język",
    voiceOn: "Sterowanie głosem",
    voiceOff: "Wyłącz głos",
    listening: "Słucham…",
    voiceHint: "Powiedz 'START' lub 'STOP'",
    voiceNotSupported: "Brak obsługi głosu",
    voiceHelpTitle: "Sterowanie głosem",
    voiceCmdStart: "Powiedz 'START' — rozpoczyna ćwiczenie",
    voiceCmdStop: "Powiedz 'STOP' — kończy ćwiczenie i pokazuje wynik",
    voiceCmdColors: "Odpowiadaj wymawiając widziany kolor (np. 'żółty')",
    voiceCmdColorsNumbers: "Odpowiadaj wymawiając widzianą cyfrę (np. 'siedem')",
    voiceCmdMath: "Odpowiadaj wymawiając wynik działania (np. 'dziesięć')",
    voiceCmdMetronome: "Steruj treningiem komendami START / STOP",
    voiceEnableHint: "Włącz przycisk 'Sterowanie głosem' i pozwól na dostęp do mikrofonu",
    tasksLabel: "Zadania",
    correctLabel: "Poprawne",
    accuracyLabel: "Skuteczność",
    sessionResult: "Wynik sesji",
    close: "Zamknij",
    tryAgain: "Spróbuj jeszcze raz",
    browserWarnSafari: "Twoja przeglądarka nie obsługuje sterowania głosem. Otwórz aplikację w Chrome lub Edge (Android / komputer), aby korzystać z komend głosowych.",
  },
  en: {
    appName: "Velocity Lab System",
    tagline: "Elite Global Performance Courses",
    chooseModule: "Choose training module",
    difficulty: "Difficulty level",
    difficultyEasy: "Easy",
    difficultyMedium: "Medium",
    difficultyHard: "Hard",
    difficultyExtreme: "Extreme",
    metronome: "Metronome",
    metronomeDesc: "4 tempos: 100 / 120 / 140 / 160 BPM",
    colors: "Colors",
    colorsDesc: "Random colors every second",
    colorsNumbers: "Colors + Numbers",
    colorsNumbersDesc: "Random colors and numbers 1–10",
    math: "Math",
    mathDesc: "Addition exercises 1–10",
    arrows: "Arrows",
    arrowsDesc: "Random arrows: up / down / left / right",
    arrowsDiag: "Arrows + diagonals",
    arrowsDiagDesc: "8 directions including diagonals",
    tutorial: "Tutorial",
    tutorialDesc: "Learn every feature step by step",
    tutorialVideoTitle: "Walkthrough video",
    tutorialVideoSoon: "This video walks through every module of the app with English captions — pick a module below to start training right away.",
    tutorialFeaturesTitle: "App features",
    tutorialOpenModule: "Open module",
    tutorialSteps: "What to do:",
    start: "Start",
    stop: "Stop",
    pause: "Pause",
    back: "Back",
    bpm: "BPM",
    selectTempo: "Select tempo",
    interval: "Display speed",
    seconds: "seconds",
    second: "second",
    settings: "Settings",
    fullscreen: "Fullscreen",
    exitFullscreen: "Exit fullscreen",
    home: "Home",
    language: "Language",
    readyToStart: "Ready to train?",
    tapToStart: "Tap START to begin",
    elapsedTime: "Training time",
    beats: "Beats",
    correctAnswers: "Correct",
    skipQuestion: "Skip",
    yourAnswer: "Your answer",
    soundOn: "Sound on",
    soundOff: "Sound off",
    welcomeSubtitle: "Professional training platform for football players",
    chooseLanguage: "Choose language",
    voiceOn: "Voice control",
    voiceOff: "Stop voice",
    listening: "Listening…",
    voiceHint: "Say \"START\" or \"STOP\"",
    voiceNotSupported: "Voice not supported",
    voiceHelpTitle: "Voice control",
    voiceCmdStart: "Say 'START' — begins the drill",
    voiceCmdStop: "Say 'STOP' — ends the drill and shows the score",
    voiceCmdColors: "Answer by saying the color you see (e.g. 'yellow')",
    voiceCmdColorsNumbers: "Answer by saying the number you see (e.g. 'seven')",
    voiceCmdMath: "Answer by saying the result of the equation (e.g. 'ten')",
    voiceCmdMetronome: "Control the drill with START / STOP commands",
    voiceEnableHint: "Enable 'Voice control' and allow microphone access",
    tasksLabel: "Tasks",
    correctLabel: "Correct",
    accuracyLabel: "Accuracy",
    sessionResult: "Session result",
    close: "Close",
    tryAgain: "Try again",
    browserWarnSafari: "Your browser doesn't support voice control. Open the app in Chrome or Edge (Android / desktop) to use voice commands.",
  },
  de: {
    appName: "Velocity Lab System",
    tagline: "Elite Global Performance Courses",
    chooseModule: "Trainingsmodul wählen",
    difficulty: "Schwierigkeitsgrad",
    difficultyEasy: "Leicht",
    difficultyMedium: "Mittel",
    difficultyHard: "Schwer",
    difficultyExtreme: "Extrem",
    metronome: "Metronom",
    metronomeDesc: "4 Tempi: 100 / 120 / 140 / 160 BPM",
    colors: "Farben",
    colorsDesc: "Zufällige Farben pro Sekunde",
    colorsNumbers: "Farben + Zahlen",
    colorsNumbersDesc: "Zufällige Farben und Zahlen 1–10",
    math: "Mathematik",
    mathDesc: "Additionsaufgaben 1–10",
    arrows: "Pfeile",
    arrowsDesc: "Zufällige Pfeile: hoch / runter / links / rechts",
    arrowsDiag: "Pfeile + diagonal",
    arrowsDiagDesc: "8 Richtungen inklusive Diagonalen",
    tutorial: "Anleitung",
    tutorialDesc: "Lerne alle Funktionen Schritt für Schritt",
    tutorialVideoTitle: "Anleitungsvideo",
    tutorialVideoSoon: "Das Video zeigt jeden Modul der App mit englischen Untertiteln — wähle unten ein Modul, um sofort mit dem Training zu starten.",
    tutorialFeaturesTitle: "App-Funktionen",
    tutorialOpenModule: "Modul öffnen",
    tutorialSteps: "Was tun:",
    start: "Start",
    stop: "Stopp",
    pause: "Pause",
    back: "Zurück",
    bpm: "BPM",
    selectTempo: "Tempo wählen",
    interval: "Anzeigegeschwindigkeit",
    seconds: "Sekunden",
    second: "Sekunde",
    settings: "Einstellungen",
    fullscreen: "Vollbild",
    exitFullscreen: "Vollbild verlassen",
    home: "Startseite",
    language: "Sprache",
    readyToStart: "Bereit zum Training?",
    tapToStart: "Tippe START zum Starten",
    elapsedTime: "Trainingszeit",
    beats: "Schläge",
    correctAnswers: "Richtig",
    skipQuestion: "Überspringen",
    yourAnswer: "Deine Antwort",
    soundOn: "Ton an",
    soundOff: "Ton aus",
    welcomeSubtitle: "Professionelle Trainingsplattform für Fußballspieler",
    chooseLanguage: "Sprache wählen",
    voiceOn: "Sprachsteuerung",
    voiceOff: "Sprache aus",
    listening: "Höre zu…",
    voiceHint: "Sage 'START' oder 'STOPP'",
    voiceNotSupported: "Sprache nicht unterstützt",
    voiceHelpTitle: "Sprachsteuerung",
    voiceCmdStart: "Sage 'START' — beginnt die Übung",
    voiceCmdStop: "Sage 'STOPP' — beendet und zeigt das Ergebnis",
    voiceCmdColors: "Antworte mit der gesehenen Farbe (z.B. 'gelb')",
    voiceCmdColorsNumbers: "Antworte mit der gesehenen Zahl (z.B. 'sieben')",
    voiceCmdMath: "Antworte mit dem Rechenergebnis (z.B. 'zehn')",
    voiceCmdMetronome: "Steuere die Übung mit START / STOPP",
    voiceEnableHint: "'Sprachsteuerung' aktivieren und Mikrofonzugriff erlauben",
    tasksLabel: "Aufgaben",
    correctLabel: "Richtig",
    accuracyLabel: "Genauigkeit",
    sessionResult: "Sitzungsergebnis",
    close: "Schließen",
    tryAgain: "Nochmal",
    browserWarnSafari: "Dein Browser unterstützt keine Sprachsteuerung. Öffne die App in Chrome oder Edge (Android / Desktop), um Sprachbefehle zu verwenden.",
  },
  es: {
    appName: "Velocity Lab System",
    tagline: "Elite Global Performance Courses",
    chooseModule: "Elige el módulo de entrenamiento",
    difficulty: "Nivel de dificultad",
    difficultyEasy: "Fácil",
    difficultyMedium: "Medio",
    difficultyHard: "Difícil",
    difficultyExtreme: "Extremo",
    metronome: "Metrónomo",
    metronomeDesc: "4 tempos: 100 / 120 / 140 / 160 BPM",
    colors: "Colores",
    colorsDesc: "Colores aleatorios cada segundo",
    colorsNumbers: "Colores + Números",
    colorsNumbersDesc: "Colores y números 1–10 aleatorios",
    math: "Matemáticas",
    mathDesc: "Ejercicios de suma 1–10",
    arrows: "Flechas",
    arrowsDesc: "Flechas aleatorias: arriba / abajo / izquierda / derecha",
    arrowsDiag: "Flechas + diagonales",
    arrowsDiagDesc: "8 direcciones incluyendo diagonales",
    tutorial: "Tutorial",
    tutorialDesc: "Aprende cada función paso a paso",
    tutorialVideoTitle: "Vídeo tutorial",
    tutorialVideoSoon: "Este vídeo recorre cada módulo de la app con subtítulos en inglés — elige un módulo abajo para empezar a entrenar.",
    tutorialFeaturesTitle: "Funciones de la app",
    tutorialOpenModule: "Abrir módulo",
    tutorialSteps: "Qué hacer:",
    start: "Inicio",
    stop: "Parar",
    pause: "Pausa",
    back: "Atrás",
    bpm: "BPM",
    selectTempo: "Seleccionar tempo",
    interval: "Velocidad de visualización",
    seconds: "segundos",
    second: "segundo",
    settings: "Ajustes",
    fullscreen: "Pantalla completa",
    exitFullscreen: "Salir de pantalla completa",
    home: "Inicio",
    language: "Idioma",
    readyToStart: "¿Listo para entrenar?",
    tapToStart: "Pulsa INICIO para empezar",
    elapsedTime: "Tiempo de entrenamiento",
    beats: "Pulsos",
    correctAnswers: "Correctas",
    skipQuestion: "Saltar",
    yourAnswer: "Tu respuesta",
    soundOn: "Sonido activado",
    soundOff: "Sonido desactivado",
    welcomeSubtitle: "Plataforma profesional de entrenamiento para futbolistas",
    chooseLanguage: "Elegir idioma",
    voiceOn: "Control por voz",
    voiceOff: "Desactivar voz",
    listening: "Escuchando…",
    voiceHint: "Di 'INICIO' o 'PARAR'",
    voiceNotSupported: "Voz no compatible",
    voiceHelpTitle: "Control por voz",
    voiceCmdStart: "Di 'INICIO' — comienza el ejercicio",
    voiceCmdStop: "Di 'PARAR' — termina y muestra el resultado",
    voiceCmdColors: "Responde diciendo el color que ves (ej. 'amarillo')",
    voiceCmdColorsNumbers: "Responde diciendo el número que ves (ej. 'siete')",
    voiceCmdMath: "Responde diciendo el resultado (ej. 'diez')",
    voiceCmdMetronome: "Controla con comandos INICIO / PARAR",
    voiceEnableHint: "Activa 'Control por voz' y permite el micrófono",
    tasksLabel: "Tareas",
    correctLabel: "Correctas",
    accuracyLabel: "Precisión",
    sessionResult: "Resultado de la sesión",
    close: "Cerrar",
    tryAgain: "Reintentar",
    browserWarnSafari: "Tu navegador no admite el control por voz. Abre la app en Chrome o Edge (Android / escritorio) para usar comandos de voz.",
  },
  fr: {
    appName: "Velocity Lab System",
    tagline: "Elite Global Performance Courses",
    chooseModule: "Choisis le module d'entraînement",
    difficulty: "Niveau de difficulté",
    difficultyEasy: "Facile",
    difficultyMedium: "Moyen",
    difficultyHard: "Difficile",
    difficultyExtreme: "Extrême",
    metronome: "Métronome",
    metronomeDesc: "4 tempos : 100 / 120 / 140 / 160 BPM",
    colors: "Couleurs",
    colorsDesc: "Couleurs aléatoires chaque seconde",
    colorsNumbers: "Couleurs + Chiffres",
    colorsNumbersDesc: "Couleurs et chiffres 1–10 aléatoires",
    math: "Maths",
    mathDesc: "Exercices d'addition 1–10",
    arrows: "Flèches",
    arrowsDesc: "Flèches aléatoires : haut / bas / gauche / droite",
    arrowsDiag: "Flèches + diagonales",
    arrowsDiagDesc: "8 directions, diagonales incluses",
    tutorial: "Tutoriel",
    tutorialDesc: "Apprends chaque fonction étape par étape",
    tutorialVideoTitle: "Vidéo de présentation",
    tutorialVideoSoon: "Cette vidéo parcourt chaque module de l'app avec sous-titres en anglais — choisis un module ci-dessous pour commencer.",
    tutorialFeaturesTitle: "Fonctions de l'app",
    tutorialOpenModule: "Ouvrir le module",
    tutorialSteps: "Que faire :",
    start: "Démarrer",
    stop: "Arrêter",
    pause: "Pause",
    back: "Retour",
    bpm: "BPM",
    selectTempo: "Choisir le tempo",
    interval: "Vitesse d'affichage",
    seconds: "secondes",
    second: "seconde",
    settings: "Paramètres",
    fullscreen: "Plein écran",
    exitFullscreen: "Quitter le plein écran",
    home: "Accueil",
    language: "Langue",
    readyToStart: "Prêt à t'entraîner ?",
    tapToStart: "Appuie sur DÉMARRER",
    elapsedTime: "Temps d'entraînement",
    beats: "Battements",
    correctAnswers: "Correctes",
    skipQuestion: "Passer",
    yourAnswer: "Ta réponse",
    soundOn: "Son activé",
    soundOff: "Son désactivé",
    welcomeSubtitle: "Plateforme d'entraînement professionnelle pour footballeurs",
    chooseLanguage: "Choisir la langue",
    voiceOn: "Commande vocale",
    voiceOff: "Désactiver la voix",
    listening: "À l'écoute…",
    voiceHint: "Dis \"DÉMARRER\" ou \"STOP\"",
    voiceNotSupported: "Voix non supportée",
    voiceHelpTitle: "Commande vocale",
    voiceCmdStart: "Dis 'DÉMARRER' — lance l'exercice",
    voiceCmdStop: "Dis 'STOP' — termine et affiche le résultat",
    voiceCmdColors: "Réponds en disant la couleur (ex. 'jaune')",
    voiceCmdColorsNumbers: "Réponds en disant le chiffre (ex. 'sept')",
    voiceCmdMath: "Réponds en disant le résultat (ex. 'dix')",
    voiceCmdMetronome: "Contrôle avec DÉMARRER / STOP",
    voiceEnableHint: "Active 'Commande vocale' et autorise le micro",
    tasksLabel: "Tâches",
    correctLabel: "Correctes",
    accuracyLabel: "Précision",
    sessionResult: "Résultat de la session",
    close: "Fermer",
    tryAgain: "Réessayer",
    browserWarnSafari: "Ton navigateur ne prend pas en charge la commande vocale. Ouvre l'application dans Chrome ou Edge (Android / bureau) pour utiliser la voix.",
  },
  uk: {
    appName: "Velocity Lab System",
    tagline: "Elite Global Performance Courses",
    chooseModule: "Оберіть тренувальний модуль",
    difficulty: "Рівень складності",
    difficultyEasy: "Легкий",
    difficultyMedium: "Середній",
    difficultyHard: "Важкий",
    difficultyExtreme: "Екстремальний",
    metronome: "Метроном",
    metronomeDesc: "4 темпи: 100 / 120 / 140 / 160 BPM",
    colors: "Кольори",
    colorsDesc: "Випадкові кольори щосекунди",
    colorsNumbers: "Кольори + Цифри",
    colorsNumbersDesc: "Випадкові кольори та цифри 1–10",
    math: "Математика",
    mathDesc: "Вправи на додавання 1–10",
    arrows: "Стрілки",
    arrowsDesc: "Випадкові стрілки: вгору / вниз / вліво / вправо",
    arrowsDiag: "Стрілки + діагоналі",
    arrowsDiagDesc: "8 напрямків з діагоналями",
    tutorial: "Підручник",
    tutorialDesc: "Дізнайтеся про всі функції крок за кроком",
    tutorialVideoTitle: "Відео-інструкція",
    tutorialVideoSoon: "Це відео проходить через усі модулі застосунку з англійськими субтитрами — оберіть модуль нижче, щоб почати тренування.",
    tutorialFeaturesTitle: "Функції додатка",
    tutorialOpenModule: "Відкрити модуль",
    tutorialSteps: "Що зробити:",
    start: "Старт",
    stop: "Стоп",
    pause: "Пауза",
    back: "Назад",
    bpm: "BPM",
    selectTempo: "Оберіть темп",
    interval: "Швидкість відображення",
    seconds: "секунд",
    second: "секунда",
    settings: "Налаштування",
    fullscreen: "Повний екран",
    exitFullscreen: "Вийти з повного екрана",
    home: "Головна",
    language: "Мова",
    readyToStart: "Готовий тренуватися?",
    tapToStart: "Натисни СТАРТ",
    elapsedTime: "Час тренування",
    beats: "Удари",
    correctAnswers: "Правильні",
    skipQuestion: "Пропустити",
    yourAnswer: "Твоя відповідь",
    soundOn: "Звук увімкнено",
    soundOff: "Звук вимкнено",
    welcomeSubtitle: "Професійна тренувальна платформа для футболістів",
    chooseLanguage: "Оберіть мову",
    voiceOn: "Голосове керування",
    voiceOff: "Вимкнути голос",
    listening: "Слухаю…",
    voiceHint: "Скажіть \"СТАРТ\" або \"СТОП\"",
    voiceNotSupported: "Голос не підтримується",
    voiceHelpTitle: "Голосове керування",
    voiceCmdStart: "Скажіть 'СТАРТ' — починає вправу",
    voiceCmdStop: "Скажіть 'СТОП' — завершує та показує результат",
    voiceCmdColors: "Відповідайте назвою кольору (наприклад 'жовтий')",
    voiceCmdColorsNumbers: "Відповідайте цифрою (наприклад 'сім')",
    voiceCmdMath: "Відповідайте результатом (наприклад 'десять')",
    voiceCmdMetronome: "Керуйте командами СТАРТ / СТОП",
    voiceEnableHint: "Увімкніть 'Голосове керування' та дозвольте мікрофон",
    tasksLabel: "Завдання",
    correctLabel: "Правильні",
    accuracyLabel: "Точність",
    sessionResult: "Результат сесії",
    close: "Закрити",
    tryAgain: "Ще раз",
    browserWarnSafari: "Ваш браузер не підтримує голосове керування. Відкрийте додаток у Chrome або Edge (Android / комп'ютер), щоб користуватися голосовими командами.",
  },
};

export function getTranslation(lang, key) {
  return (translations[lang] && translations[lang][key]) || translations.en[key] || key;
}
